import { CharacterClassIcon } from 'app/frontend/base/components'
import BlizzardIcon from 'app/frontend/base/components/BlizzardIcon'
import { getAllSpecializations } from 'app/frontend/base/services/characterValues'
import { CharacterClass } from 'app/frontend/types/custom'
import { classColours } from 'app/frontend/types/custom/CharacterClass'
import { ReactNode } from 'react'
import { TFunction } from 'i18next'
import { getAssignmentEntityLabel } from '../../TeamPlans/components/assignmentEntityLabels'
import { ResolvedAssignmentEntity } from './eventActivityTimelineResolver'
import { getResolvedAssignmentLabelEntity } from './resolvedAssignmentEntityLabels'

const specializationById = getAllSpecializations()

export const renderResolvedAssignmentEntityLabel = ({
  t,
  entity,
  participantClassByCharacterId = {},
}: {
  t: TFunction
  entity: ResolvedAssignmentEntity
  participantClassByCharacterId?: Record<
    number,
    wowaudit.CharacterReference['characterClass']
  >
}): ReactNode => {
  if (entity.kind === 'ignored') {
    return (
      <span className='truncate text-muted-foreground opacity-50'>Ignored</span>
    )
  }
  if (entity.kind === 'participant') {
    const specialization = entity.participant.specId
      ? specializationById[entity.participant.specId.toString()]
      : undefined
    return (
      <span className='inline-flex min-w-0 max-w-full items-center gap-1'>
        {specialization ? (
          <BlizzardIcon
            iconName={specialization.icon}
            size='small'
            className='shrink-0'
          />
        ) : (
          <CharacterClassIcon
            characterClass={entity.participant.characterClass as CharacterClass}
            size='small'
            className='shrink-0'
          />
        )}
        <span
          className={`${
            classColours[entity.participant.characterClass].text
          } truncate`}
        >
          {entity.participant.name}
        </span>
      </span>
    )
  }

  const labelEntity = getResolvedAssignmentLabelEntity({
    resolvedEntity: entity,
    fallbackEntity: entity.sourceEntity,
  })
  if (labelEntity.kind === 'member') {
    const characterClass =
      participantClassByCharacterId[labelEntity.character_id]
    if (characterClass) {
      return (
        <span className='inline-flex min-w-0 max-w-full items-center gap-1'>
          <CharacterClassIcon
            characterClass={characterClass as CharacterClass}
            size='small'
            className='shrink-0'
          />
          <span className='min-w-0 truncate text-muted-foreground'>
            {getAssignmentEntityLabel(t, labelEntity)}
          </span>
        </span>
      )
    }
  }
  return getAssignmentEntityLabel(t, labelEntity)
}
